var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('div',{class:_vm.$style.content},[_c('landing-header',{class:['no-print', _vm.$style.header]}),_vm._v(" "),_c('main',{class:[
        'content',
        _vm.$style.inner, ( _obj = {}, _obj[_vm.$style.innerFullWidth] = _vm.settings.fullWidth, _obj )
      ]},[_vm._t("default")],2),_vm._v(" "),_c('lazy-hydrate',{attrs:{"when-visible":""}},[_c('landing-footer',{staticClass:"no-print"})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }